import { DOCUMENT, inject, Injectable } from '@angular/core';
import { EspaceClientEvent, GtmEvent } from '@services/data-layer/models';

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  readonly #window: Window = inject(DOCUMENT).defaultView as Window;

  constructor() {
    this.#window.dataLayer = this.#window.dataLayer || [];
  }

  logEvent(event: Omit<GtmEvent, 'event'>): void {
    const hit: GtmEvent = {
      event: 'screen_event',
      event_code: event.event_code,
    };
    if (event['button_text_value']) hit['button_text_value'] = event.button_text_value;
    if (event['context']) hit['context'] = event.context;
    if (event['zone']) hit['zone'] = event.zone;
    if (event['description']) hit['description'] = event.description;
    if (event['search_term']) hit['search_term'] = event.search_term;
    this.#sendEvent(hit);
  }

  logEspaceClientEvent(event: EspaceClientEvent): void {
    this.#sendEvent(event);
  }

  #sendEvent(obj: GtmEvent | EspaceClientEvent): void {
    if (obj) this.#window.dataLayer.push(obj);
  }
}
